import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { ClientStore, ClientState } from './client.store';
import { Client } from '@state/clients/client.model';
import { combineLatest, Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ClientQuery extends QueryEntity<ClientState> {

    getCurrentClient(): Client {
        return this.getValue().currentClient;
    }

    selectCurrentClient(): Observable<Client> {
        return this.select('currentClient');
    }

    getIsLastPage(): boolean {
        return this.getCurrentPage() >= this.getPages();
    }

    selectIsLastPage(): Observable<boolean> {
        return combineLatest([this.selectCurrentPage(), this.selectPages()])
            .pipe(map(([currentPage, pages]) => currentPage >= pages));
    }

    getCurrentPage(): number {
        return this.getValue().currentPage;
    }

    selectCurrentPage(): Observable<number> {
        return this.select('currentPage');
    }

    getPages(): number {
        return this.getValue().pages;
    }

    selectPages(): Observable<number> {
        return this.select('pages');
    }

    constructor(protected store: ClientStore, private sanitizer: DomSanitizer) {
        super(store);
    }

}
